import React from 'react';
import UpdateIndicator from '../../../../atoms/update-indicator';

const getRowActions = (row, t, navigate) => {
  const breadcrumbName = `${row.name} ${row.last_name}`;

  return [
    {
      key: 'profile',
      label: t('pma-hac-tab-option1'),
      onClick: () => navigate(`/common/personal-details/${row.id}`, {
        state: { breadcrumbName },
      }),
    },
    {
      key: 'vehicles',
      label: t('pma-hac-tab-option2'),
      onClick: () => navigate(`/common/vehicles/${row.id}`, {
        state: { breadcrumbName },
      }),
    },
    {
      key: 'preferences',
      label: t('pma-hac-tab-option3'),
      onClick: () => navigate(`/common/preferences/${row.id}`, {
        state: { breadcrumbName },
      }),
    },
    {
      key: 'retailer-info',
      label: t('pma-hac-tab-option4'),
      onClick: () => navigate(`/pma/retailer-info/${row.id}`, {
        state: { breadcrumbName },
      }),
    },
    {
      key: 'pma-info',
      label: t('pma-hac-tab-option5'),
      onClick: () => navigate(`/pma/pma-info/${row.id}`, {
        state: { breadcrumbName },
      }),
    },
    {
      key: 'activity-log',
      label: t('pma-hac-tab-option8'),
      trailingContent: row.notification === true ? <UpdateIndicator /> : null,
      onClick: () => navigate(`/common/activity-log/${row.id}`, {
        state: { breadcrumbName },
      }),
    },
    {
      key: 'surveys',
      label: t('common-surveys'),
      onClick: () => navigate(`/pma/surveys/${row.id}`, {
        state: { breadcrumbName },
      }),
    },
    {
      key: 'shared-notes',
      label: t('pma-hac-tab-option7'),
      onClick: () => navigate(`/pma/shared-notes/${row.id}`, {
        state: { breadcrumbName },
      }),
    },
    {
      key: 'assigned-tasks',
      label: t('pma-hac-tab-option9'),
      onClick: () => window.open(`/pma/calendar?memberId=${row.id}&mode=list&period=month`, '_blank'),
    },
    {
      key: 'unenroll',
      label: t('pma-hac-tab-option6'),
      disabled: row.status === 'exited',
      className: row.status === 'exited' ? 'disabled' : '',
      onClick: () => navigate(`/pma/unenroll/${row.id}`, {
        state: {
          name: row.name,
          lastName: row.last_name,
          breadcrumbName,
        },
      }),
    },
  ];
};

export default getRowActions;
